/*
 * Copyright (c) Dito Technologies LLC
 */

const midiToFrequency: { [midi: number]: number | undefined } = {
    127: 12543.85,
    126: 11839.82,
    125: 11175.30,
    124: 10548.08,
    123: 9956.06,
    122: 9397.27,
    121: 8869.84,
    120: 8372.02,
    119: 7902.13,
    118: 7458.62,
    117: 7040.00,
    116: 6644.88,
    115: 6271.93,
    114: 5919.91,
    113: 5587.65,
    112: 5274.04,
    111: 4978.03,
    110: 4698.64,
    109: 4434.92,
    108: 4186.01,
    107: 3951.07,
    106: 3729.31,
    105: 3520.00,
    104: 3322.44,
    103: 3135.96,
    102: 2959.96,
    101: 2793.83,
    100: 2637.02,
    99: 2489.02,
    98: 2349.32,
    97: 2217.46,
    96: 2093.00,
    95: 1975.53,
    94: 1864.66,
    93: 1760.00,
    92: 1661.22,
    91: 1567.98,
    90: 1479.98,
    89: 1396.91,
    88: 1318.51,
    87: 1244.51,
    86: 1174.66,
    85: 1108.73,
    84: 1046.50,
    83: 987.77,
    82: 932.33,
    81: 880.00,
    80: 830.61,
    79: 783.99,
    78: 739.99,
    77: 698.46,
    76: 659.26,
    75: 622.25,
    74: 587.33,
    73: 554.37,
    72: 523.25,
    71: 493.88,
    70: 466.16,
    69: 440.00,
    68: 415.30,
    67: 392.00,
    66: 369.99,
    65: 349.23,
    64: 329.63,
    63: 311.13,
    62: 293.66,
    61: 277.18,
    60: 261.63,
    59: 246.94,
    58: 233.08,
    57: 220.00,
    56: 207.65,
    55: 196.00,
    54: 185.00,
    53: 174.61,
    52: 164.81,
    51: 155.56,
    50: 146.83,
    49: 138.59,
    48: 130.81,
    47: 123.47,
    46: 116.54,
    45: 110.00,
    44: 103.83,
    43: 98.00,
    42: 92.50,
    41: 87.31,
    40: 82.41,
    39: 77.78,
    38: 73.42,
    37: 69.30,
    36: 65.41,
    35: 61.74,
    34: 58.27,
    33: 55.00,
    32: 51.91,
    31: 49.00,
    30: 46.25,
    29: 43.65,
    28: 41.20,
    27: 38.89,
    26: 36.71,
    25: 34.65,
    24: 32.70,
    23: 30.87,
    22: 29.14,
    21: 27.50,
    20: 25.96,
    19: 24.50,
    18: 23.12,
    17: 21.83,
    16: 20.60,
    15: 19.45,
    14: 18.35,
    13: 17.32,
    12: 16.35,
    11: 15.43,
    10: 14.57,
    9: 13.75,
    8: 12.98,
    7: 12.25,
    6: 11.56,
    5: 10.91,
    4: 10.30,
    3: 9.72,
    2: 9.18,
    1: 8.66,
    0: 8.18
};

export type PITCH =
    "A"
    | "B"
    | "C"
    | "D"
    | "E"
    | "F"
    | "G"
    | "A_SHARP"
    | "B_FLAT"
    | "C_SHARP"
    | "D_FLAT"
    | "D_SHARP"
    | "E_FLAT"
    | "F_SHARP"
    | "G_FLAT"
    | "G_SHARP"
    | "A_FLAT";

export function CanMakeNatural(pitch: PITCH): boolean {
    switch (pitch) {
        case "A_SHARP":
            return true
        case "B_FLAT":
            return true;
        case "C_SHARP":
            return true;
        case "D_FLAT":
            return true;
        case "D_SHARP":
            return true
        case "E_FLAT":
            return true;
        case "F_SHARP":
            return true;
        case "G_FLAT":
            return true;
        case "G_SHARP":
            return true;
        case "A_FLAT":
            return true;
        default:
            return false;
    }
}

export function CanMakeSharp(pitch: PITCH): boolean {
    switch (pitch) {
        case "A":
            return true;
        case "C":
            return true;
        case "D":
            return true;
        case "F":
            return true;
        case "G":
            return true;
        default:
            return false;
    }
}

export function CanMakeFlat(pitch: PITCH): boolean {
    switch (pitch) {
        case "A":
            return true;
        case "B":
            return true;
        case "D":
            return true;
        case "E":
            return true;
        case "G":
            return true;
        default:
            return false;
    }
}

export function IsSharpOrFloat(pitch: PITCH): boolean {
    return IsFlat(pitch) || IsSharp(pitch);
}

export function IsFlat(pitch: PITCH): boolean {
    switch (pitch) {
        case "A_FLAT":
            return true;
        case "B_FLAT":
            return true;
        case "D_FLAT":
            return true;
        case "E_FLAT":
            return true;
        case "G_FLAT":
            return true;
        default:
            return false;
    }
}

export function IsSharp(pitch: PITCH): boolean {
    switch (pitch) {
        case "A_SHARP":
            return true;
        case "C_SHARP":
            return true;
        case "D_SHARP":
            return true;
        case "F_SHARP":
            return true;
        case "G_SHARP":
            return true;
        default:
            return false;
    }
}

export function MIDITOPitch(midi: number): PITCH {
    switch (midi % 12) {
        case 0:
            return "C"
        case 1:
            return "C_SHARP"
        case 2:
            return "D"
        case 3:
            return "D_SHARP"
        case 4:
            return "E"
        case 5:
            return "F"
        case 6:
            return "F_SHARP"
        case 7:
            return "G"
        case 8:
            return "G_SHARP"
        case 9:
            return "A"
        case 10:
            return "A_SHARP"
        case 11:
            return "B"
        default:
            return "A"
    }
}

export default function PitchToName(pitch: PITCH): string {
    switch (pitch) {
        case "A":
            return "A";
        case "B":
            return "B";
        case "C":
            return "C";
        case "D":
            return "D";
        case "E":
            return "E";
        case "F":
            return "F";
        case "G":
            return "G";
        case "A_SHARP":
            return "A♯"
        case "A_FLAT":
            return "A♭"
        case "B_FLAT":
            return "B♭"
        case "C_SHARP":
            return "C♯"
        case "D_SHARP":
            return "D♯"
        case "D_FLAT":
            return "D♭"
        case "E_FLAT":
            return "E♭"
        case "F_SHARP":
            return "F♯"
        case "G_SHARP":
            return "G♯"
        case "G_FLAT":
            return "G♭"
    }
}

export function LineIDXToPitch(lineIdx: number): PITCH {
    const pitchesInLineIdxOrder: PITCH[] = [
        "F",
        "E",
        "D",
        "C",
        "B",
        "A",
        "G"
    ]
    if (lineIdx >= 0) {
        const mod = lineIdx % pitchesInLineIdxOrder.length;
        return pitchesInLineIdxOrder[mod];
    } else {
        const mod = Math.abs(lineIdx) & pitchesInLineIdxOrder.length;
        return pitchesInLineIdxOrder[pitchesInLineIdxOrder.length - mod];
    }

}

export function MIDIToPitchName(midi: number): string {
    const pitch = MIDITOPitch(midi);
    return PitchToName(pitch);
}

export function MIDIToFrequency(midi: number): number {
    return midiToFrequency[midi] || 0;
}